/**
 * APIリクエスト
 */
export default class Request {
  /**
   * コンストラクタ
   * @param data データ
   */
  constructor (data) {
    if (data) {
      this._data = data
    } else {
      this._data = {}
    }
  }

  /**
   * データを取得
   */
  get data () {
    return this._data
  }
}
